import { render, staticRenderFns } from "./servicesSvg.vue?vue&type=template&id=2c29605e&"
import script from "./servicesSvg.vue?vue&type=script&lang=js&"
export * from "./servicesSvg.vue?vue&type=script&lang=js&"
import style0 from "./servicesSvg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports